import api from './api'

const getContentTags = () => api.get('/api/colleges/content/search/tags')

const contentTagsService = {
  getContentTags,
}

export default contentTagsService
